<template>
  <li class="p-content-plan-manual-ranking-texts__item">
    <div>
      <span v-if="item.isOwnSite" class="own-site">
        登録サイト
      </span>
    </div>
    <template v-if="!item.url && item.isOwnSite">
      <span class="p-content-plan-manual-ranking-texts__rank">圏外</span>
      <p>
        100位以内に登録サイトのデータが存在しません。
      </p>
    </template>
    <template v-else>
      <span class="p-content-plan-manual-ranking-texts__rank"
        >{{ item.rank }}位</span
      >
      <template v-if="item.isLoading">
        <p>
          データを取得中です。
        </p>
      </template>
      <template v-else-if="item.contentType === 'pdf'">
        <p>
          PDFのため分析ができません。
        </p>
      </template>
      <template v-else-if="!item.content">
        <p>データがありませんでした。</p>
      </template>
      <template v-else>
        <div class="p-content-plan-manual-ranking-texts__content">
          <a
            :href="item.url"
            target="_blank"
            :aria-label="item.url"
            class="c-icon--blank"
          >
          </a>
          <EllipsisTip>{{ item.content }}</EllipsisTip>
        </div>
      </template>
    </template>
  </li>
</template>

<script>
import EllipsisTip from '@/components/EllipsisTip';
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  components: {
    EllipsisTip
  }
};
</script>
